import { Table } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { KeyedRow } from '../../components/KeyedRow';
import { PageHeader } from '../../components/PageHeader';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import { CashDeclarationRow } from './components/CashDeclarationRow';
import type { CashDeclarationDto } from './types/CashDeclarationDto';

export function CashDeclarations() {
	const { organisation } = useParams();

	const filter = useFilter();
	const pagination = usePagination();

	const cashDeclarationQuery = queryWithFilterAndPages<CashDeclarationDto[]>(
		`${organisation}/cash-declaration/all`,
		filter.value,
		pagination.value,
	);

	const cashDeclarationCountQuery = queryWithFilter<number>(
		`${organisation}/cash-declaration/count`,
		filter.value,
	);

	return (
		<>
			<PageHeader title={'Cash Declarations'} filter={filter} />
			<DataTable
				pagination={pagination}
				totalItems={cashDeclarationCountQuery.data?.value}
				isRowsLoading={cashDeclarationQuery.isLoading}
				isPaginationLoading={cashDeclarationCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'Branch'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Date'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Date'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Cash'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Banked'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Float'} />
						</Table.Th>
						<Table.Th>
							<Title label={'£20.00'} />
						</Table.Th>
						<Table.Th>
							<Title label={'£10.00'} />
						</Table.Th>
						<Table.Th>
							<Title label={'£5.00'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Coins'} />
						</Table.Th>
						<Table.Th>
							<Title label={'BankType'} />
						</Table.Th>
						<Table.Th>
							<Title label={'EOD Logs'} />
						</Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{cashDeclarationQuery.data?.value.map((p) => (
						<CashDeclarationRow originalCashDeclaration={p} />
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
